import { closeSnackbar, enqueueSnackbar, SnackbarKey } from 'notistack';
import { SNACKBAR_SEVERITY } from '../data-types/enums';
import { SnackbarOptions } from '../data-types/snackbar/snackbarInterfaces';
import { AUTO_HIDE_SNACKBAR_MS } from '../data-types/timing/timingEnums';
import { PATHS } from '../routing-system/appPaths';
import { setSystemBetSelectionOverviewDialogData } from '../state/actions/dialogActions';
import { store } from '../state/store';

export const getDefaultSnackbarOptions = () => ({
  autoHideDuration: AUTO_HIDE_SNACKBAR_MS.DEFAULT,
  variant: SNACKBAR_SEVERITY.ERROR,
  preventDuplicate: true,
});

export const enqueueSnackbarPrompt = (message: string, options: SnackbarOptions) => {
  const { closeOnClick, autoHideDuration, variant } = options;

  const key: SnackbarKey = enqueueSnackbar(message, {
    ...getDefaultSnackbarOptions(),
    SnackbarProps: {
      onClick: closeOnClick ? () => closeSnackbar(key) : undefined,
    },
    autoHideDuration: autoHideDuration || AUTO_HIDE_SNACKBAR_MS.DEFAULT,
    variant: variant || SNACKBAR_SEVERITY.ERROR,
  });
};

export const handleSystemBetSelectionOverviewDialogClose = () => {
  setSystemBetSelectionOverviewDialogData({ open: false, selections: [], sportBetTab: undefined });
};

export const doesNotInterruptUserActions = () => {
  const {
    userData: { terms },
    dialogs: {
      queuedDialogs,
      queuedNotifications,
      promptDisplayStatus: { reviewOpen },
      isInboxOpen,
    },
    iframe: {
      iframeSource: { payment, feedback, stream },
      isZendeskOpen,
    },
    tickets: { queuedTickets },
    signup: {
      dialogs: { signupChoiceDialogOpen, signupDialogOpen, zimplerSignupDialogOpen },
    },
  } = store.getState();

  const hasNoQueuedDialogs = queuedDialogs.length === 0 && queuedNotifications.length === 0 && queuedTickets.length === 0 && !reviewOpen;
  const hasNoIframeOpen = !payment && !feedback && !stream.source;
  const isNotReadingTerms = terms.accepted;
  const doesNotHaveZendeskOpen = !isZendeskOpen;
  const doesNotHaveInboxOpen = !isInboxOpen;
  const isNotOnBetslipPage = !window.location.pathname.startsWith(PATHS.APP.BETSLIP);
  const isNotPlayingCasinoGame = !window.location.pathname.startsWith(PATHS.APP.CASINO.GAME);
  const isNotPlayingAviatorGame = !window.location.pathname.startsWith(PATHS.APP.AVIATOR);
  const isNotSigningUp = !signupDialogOpen && !signupChoiceDialogOpen && !zimplerSignupDialogOpen;

  return (
    isNotSigningUp &&
    hasNoQueuedDialogs &&
    hasNoIframeOpen &&
    isNotReadingTerms &&
    doesNotHaveZendeskOpen &&
    doesNotHaveInboxOpen &&
    isNotOnBetslipPage &&
    isNotPlayingCasinoGame &&
    isNotPlayingAviatorGame
  );
};
